import { render, staticRenderFns } from "./RoutingRules.vue?vue&type=template&id=684846f8&"
import script from "./RoutingRules.js?vue&type=script&lang=js&"
export * from "./RoutingRules.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports